export const isDev = process.env.REACT_APP_ENVIRONMENT === "development";
